import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationDialogService } from '../../confirmation-dialog/confirmation-dialog.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DhukanDataService } from 'src/app/services/dhukan/dhukan-data.service';
import { LoginDataService } from 'src/app/services/dhukan/login-data.service';
import { ActivatedRoute } from '@angular/router';
@Component({
  selector: 'app-addlocality',
  templateUrl: './addlocality.component.html',
  styleUrls: ['./addlocality.component.css']
})
export class AddlocalityComponent implements  OnInit {

  //Mode Values
  isaddmode: boolean = false;
  iseditmode: boolean = false;
  isdeletemode: boolean = false;
  isviewmode: boolean = false;

  //Save Validation
  submitted: boolean;
  successfully: boolean;
  saveloading: boolean;

  //Edit Get Values
  localityColl: any = [];
 

  countryColl: any = [];
  stateColl: any = [];
  //pageColl:any=[];

  localityform = new FormGroup({
    localityid: new FormControl(0),
    locality: new FormControl('', Validators.required),
    inactive: new FormControl(false),
  });

  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;
  formname: String = "Locality";

  @Input() localityid: number = 0
  @Input() localityname: any = '';
  @Output() emitData = new EventEmitter();

  constructor(private toastr: ToastrService, private appService: DhukanDataService, private route: ActivatedRoute,
    private loginService: LoginDataService, private activeModal: NgbActiveModal, private confirmationDialogService: ConfirmationDialogService) {
    this.route.queryParams.subscribe(params => {
      if (params.id !== undefined) {
        this.localityid = params.id
      }
    });
    this.fnServiceChanges();
  }

  fnServiceChanges() {
    this.loginService.serviceloginChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
      if (this.loginService.fnCheckUser()) {

        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnCompanyFaildRedirect();
      }         
      }
      else {
        this.fnUserFailedForm();
      }
    });
  }

  ngOnInit() {
    try {
      if (this.loginService.fnCheckCompany()) {
      if (this.loginService.fnCheckUser()) {
        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnGetUserRoleList();
      }
    }
    else {
      this.loginService.fnCompanyFaildRedirect();
    }         
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnOnInitForm() {
    try {
      this.isaddmode = true;
      this.localityform.reset();
      this.fnInitializeLocality();

      if (this.localityid > 0) {
        this.fngetLocality();
      }
    
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }



  fnCheckUserPririvilage() {
    var _check: boolean = false;
    if (this.localityid > 0) {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')
    } else {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE')
    }

    return _check;
  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }


  fnInitializeLocality() {
    this.localityform.setValue({

      localityid: 0,
      locality: '',
      inactive:false,
    })
  }
 
  //Get 
  fngetLocality() {
   
    var data = {
      'localityid': this.localityid,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getLocality(data)
      .subscribe(
        (res) => {
          this.localityColl = res.json().result;
          var editdata = this.localityColl[0];
          this.fnEditMode(editdata);
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }


  //Save Btn Click
  fnSaveBtnClick() {
 
    try {
      if(this.saveloading){
        return
      }
      this.submitted = true;
      this.successfully = false;
      //Validate
      if (this.localityform.valid) {
        this.saveloading=true

        //Check
        var data = {
          'localityid': this.localityid,
          'locality': this.localityform.get('locality').value,
          'companyid': this.loginService.fnGetCompanyId(),
          'inactive': this.localityform.get('inactive').value,
          'createdby': this.loginService.fnGetModUserId(),
          'modifiedby': this.loginService.fnGetModUserId(),
        }
      
        this.appService.fnCheckLocality(data).subscribe(
          (res) => {
            //console.log(res)
            var _checkresult = res.json().result[0].checkfield;

            if (_checkresult === "done") {
              if (this.localityform.get('localityid').value > 0) {
                //Update Department
                this.fnSetLocality(data);
              }
              else {
                //Insert Department
                this.fnInsertLocality(data);
              }
            }
            else {
              if (_checkresult === "name") {
                this.saveloading=false;

                this.localityform.controls['locality'].setErrors({ 'notfound': true });
              }
            }
          },
          (err) => {
            this.saveloading=false;

            this.toastr.error('Error', err);
          });
      }
    } catch (ex) {
      this.saveloading=false;

      this.fnShowErrorMsg(ex);
    }
  }

  //Insert
  fnInsertLocality(data) {

    this.appService.fnInsertLocality(data).subscribe(
      (res) => {
        this.saveloading=false;

        if (res.json().status === 200) {

          var result = res.json().result;

          var rtnlocalityid = 0;
          if (result.length > 0) {
            rtnlocalityid = result[0].localityid
         
           
          }
          this.toastr.success('', "The new Locality has been added successfully.Insert Successfully");

          this.fnInsertActivityLog('INSERT', 0, data.localityid);

          this.emitData.emit(rtnlocalityid);
          this.activeModal.close(true);
        }
      },
      (err) => {
        this.saveloading=false;

        this.toastr.error('Error', err);
      });

  }

  //Set
  fnSetLocality(data) {

    this.appService.fnSetLocality(data).subscribe(
      (res) => {
        this.saveloading=false;

        if (res.json().result != "") {
          this.toastr.success('', "The Locality has been updated successfully.");

          this.fnInsertActivityLog('EDIT', this.localityid, data.localityname);

          this.emitData.emit(this.localityid);
          this.activeModal.close(true);
        }
      },
      (err) => {
        this.saveloading=false;

        this.toastr.error('Error', err);
      });

  }



  private fnEditMode(deptBO) {

    this.localityform.setValue({

      localityid: deptBO.localityid,
      locality: deptBO.locality,
      inactive: deptBO.inactive,
    });

    this.isaddmode = false;
    this.iseditmode = true;
    this.isdeletemode = false;
    this.isviewmode = false;
  }



  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc,
        logby: this.loginService.fnGetModUserId(),
        'companyid': this.loginService.fnGetCompanyId(),

      }


       this.appService.fnInsertActivity(data).subscribe(
         (res)=>{
         },
         (err)=>{

         });

    } catch {

    }
  }



  public decline() {
    this.activeModal.close(false);
  }



  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }





}
